class UtilsFormule {
  formatDateMonth(date) {
    var cdate = new Date(date);
    let month = String(cdate.getMonth() + 1).padStart(2, "0");
    let year = cdate.getFullYear();
    return month + "/" + year;
  }
  formatDateYear(date) {
    var cdate = new Date(date);
    let year = cdate.getFullYear();
    return year;
  }
  formatDateWeek(date) {
    const cdate = new Date(date);
    const firstDayOfMonth = new Date(cdate.getFullYear(), cdate.getMonth(), 1);
    const dayOfMonth = cdate.getDate();
    // Get the first day of the week (0 = Sunday, 1 = Monday, etc.)
    const firstDayOfWeek = firstDayOfMonth.getDay();
    // Calculate the week number
    const weekNumber = Math.ceil((dayOfMonth + firstDayOfWeek) / 7);
    return weekNumber;
  }
  formatDate(date) {
    var cdate = new Date(date);
    var day = String(cdate.getDate()).padStart(2, "0");
    let month = String(cdate.getMonth() + 1).padStart(2, "0");
    let year = cdate.getFullYear();
    return day + "/" + month + "/" + year;
  }

  formatDateJournal(date) {
    var cdate = new Date(date);
    var day = String(cdate.getDate()).padStart(2, "0");
    let month = String(cdate.getMonth() + 1).padStart(2, "0");
    let year = cdate.getFullYear();
    return year + "-" + month + "-" + day;
  }
  formatDateInput(date) {
    const now = new Date(date);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const dateFormated = `${year}-${month}-${day}T${hours}:${minutes}`;
    return dateFormated;
  }
  formatDateForBackend(date) {
    const now = new Date(date);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const dateFormated = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    return dateFormated;
  }
  formatDateHours(date) {
    var cdate = new Date(date);
    var day = String(cdate.getDate()).padStart(2, "0");
    let month = String(cdate.getMonth() + 1).padStart(2, "0");
    let year = cdate.getFullYear();
    let hours = String(cdate.getHours()).padStart(2, "0");
    let minutes = String(cdate.getMinutes()).padStart(2, "0");
    let seconds = String(cdate.getSeconds()).padStart(2, "0");

    return (
      day +
      "/" +
      month +
      "/" +
      year +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }

  //discount sur tt devis
  CalculateNewPurchasingPriceAfterDiscount = (
    productTableData,
    discount,
    discountType
  ) => {
    console.log("productTableData", productTableData);
    let sumTt = 0;
    // let sumHt = 0;
    let htprice = 0;
    let sumPromotionHt = 0;
    let sumPromotionTt = 0;
    let sumPriceHt = 0;
    for (let index = 0; index < productTableData.length; index++) {
      htprice =
        productTableData[index].initialPriceHtc *
        productTableData[index].quantity;
      console.log("product in calcul", productTableData[index]);
      sumPriceHt = htprice + sumPriceHt;

      sumPromotionTt = productTableData[index].ttPrice + sumPromotionTt;
      // sumPromotionHt = productTableData[index].htPrice + sumPromotionHt;
      sumPromotionHt = htprice + sumPromotionHt;
    }

    if (discount === 0) {
    } else if (discount !== 0) {
      if (discountType === "montant") {
        // sumPriceHt = 0;
        sumPromotionHt = 0;
        sumPromotionTt = 0;
        // for (let index = 0; index < productTableData.length; index++) {
        //   sumPriceHt =
        //     productTableData[index].initialPriceHtc *
        //       productTableData[index].quantity +
        //     sumPriceHt;
        // }

        let pourcentAmount = (discount / sumPriceHt) * 100;
        for (let index = 0; index < productTableData.length; index++) {
          let x = htprice - (htprice * pourcentAmount) / 100;
          let xtc = x + (x * productTableData[index].tva) / 100;
          sumPromotionHt = x + sumPromotionHt;
          sumPromotionTt = xtc + sumPromotionTt;
        }
        discount = pourcentAmount;
      } else {
        sumPromotionHt = 0;
        sumPromotionTt = 0;
        for (let index = 0; index < productTableData.length; index++) {
          htprice =
            productTableData[index].buyingPriceU *
            productTableData[index].quantity;
          // sumPriceHt = productTableData[index].htPrice + sumPriceHt;
          let x = htprice - (htprice * discount) / 100;
          let xtc = x + (x * productTableData[index].tva) / 100;
          sumPromotionHt = x + sumPromotionHt;
          sumPromotionTt = xtc + sumPromotionTt;
        }
      }
    }

    return [sumTt, sumPromotionHt, sumPromotionTt, sumPriceHt, discount];
  };
  CalculateNewPurchasingDataTableAfterDiscount = (
    productTableData,
    discount
  ) => {
    if (discount === 0) {
    } else if (discount !== 0) {
      // sumPromotionHt = 0;
      // sumPromotionTt = 0;
      for (let index = 0; index < productTableData.length; index++) {
        // sumPriceHt = productTableData[index].htPrice + sumPriceHt;
        let x =
          productTableData[index].buyingPriceU -
          (productTableData[index].buyingPriceU * discount) / 100;
        let percent = 100 - (x / productTableData[index].initialPriceHtc) * 100;

        // let xtc = x + (x * productTableData[index].tva) / 100;
        // sumPromotionHt = x + sumPromotionHt;
        // sumPromotionTt = xtc + sumPromotionTt;
        productTableData[index].buyingPriceU = x;
        // productTableData[index].ttPrice = xtc;
        productTableData[index].promotionPercentage = percent;
      }
    }

    return productTableData;
  };

  CalculateNewSellingDataTableAfterDiscount = (productTableData, discount) => {
    if (discount === 0) {
    } else if (discount !== 0) {
      // sumPromotionHt = 0;
      // sumPromotionTt = 0;
      for (let index = 0; index < productTableData.length; index++) {
        // sumPriceHt = productTableData[index].htPrice + sumPriceHt;
        let x =
          productTableData[index].buyingPriceU -
          (productTableData[index].buyingPriceU * discount) / 100;
        let percent = 100 - (x / productTableData[index].initialPriceHtc) * 100;

        // let xtc = x + (x * productTableData[index].tva) / 100;
        // sumPromotionHt = x + sumPromotionHt;
        // sumPromotionTt = xtc + sumPromotionTt;
        productTableData[index].buyingPriceU = x;
        // productTableData[index].ttPrice = xtc;
        productTableData[index].promotionPercentage = percent;
      }
    }

    return productTableData;
  };

  CalculatePromotionProductPurchase = (
    promotion,
    promotionType,
    unitPrice,
    quantity,
    tva
  ) => {
    let promotionAmountOrPersentage = 0;
    let promotionpercent = 0;
    let buyingPriceU = 0;
    let ttPrice = 0;
    if (promotion !== 0) {
      let htPrice = unitPrice * quantity;
      if (promotionType === "montant") {
        promotionAmountOrPersentage =
          Math.round((htPrice - promotion * quantity) * 100) / 100;
        promotionpercent = (promotion / unitPrice) * 100;
        buyingPriceU = Math.round((unitPrice - promotion) * 100) / 100;
        ttPrice =
          promotionAmountOrPersentage +
          (promotionAmountOrPersentage / 100) * tva;
      } else {
        promotionAmountOrPersentage =
          Math.round((htPrice - (htPrice / 100) * promotion) * 100) / 100;
        buyingPriceU =
          Math.round((unitPrice - (unitPrice / 100) * promotion) * 100) / 100;

        promotionpercent = promotion;
        ttPrice =
          promotionAmountOrPersentage +
          (promotionAmountOrPersentage / 100) * tva;
      }
    } else {
      promotionAmountOrPersentage = unitPrice * quantity;
      buyingPriceU = unitPrice;
      promotionpercent = 0;
      ttPrice =
        promotionAmountOrPersentage + (promotionAmountOrPersentage / 100) * tva;
    }

    return [
      promotionAmountOrPersentage,
      buyingPriceU,
      promotionpercent,
      ttPrice,
    ];
  };


  CalculatePromotionProductPurchaseWithTaxes = (
    promotion,
    promotionType,
    unitPrice,
    quantity,
    tva, rateTable
  ) => {
    let promotionAmountOrPersentage = 0;
    let promotionpercent = 0;
    let buyingPriceU = 0;
    let ttPrice = 0;
    let ratesOnHTC = 0;
    let ratesOnTTC = 0;
    console.log("rates", rateTable)
    rateTable.map((element) => {
      if (element.typeTVA === 2) {

        ratesOnHTC = Number(ratesOnHTC) + Number(element.value);

      } else if (element.typeTVA === 1) {
        ratesOnTTC = Number(ratesOnTTC) + Number(element.value);

      }
    })
    console.log("ratesOnHTC", ratesOnHTC)
    console.log("ratesOnTTC", ratesOnTTC)


    ratesOnTTC = Number(ratesOnTTC) * Number(quantity);
    if (promotion !== 0) {
      ratesOnHTC = Number(ratesOnHTC) * Number(quantity);
      let htPrice = unitPrice  * quantity;

      if (promotionType === "montant") {
        promotionAmountOrPersentage = Number(ratesOnHTC)+
          Math.round((htPrice - promotion * quantity) * 100) / 100;
        promotionpercent = (promotion / unitPrice) * 100;
        buyingPriceU = Math.round((unitPrice - promotion) * 100) / 100;

        ttPrice =
          promotionAmountOrPersentage +
          (promotionAmountOrPersentage / 100) * tva + ratesOnTTC;
      } else {
        promotionAmountOrPersentage = Number(ratesOnHTC)+
          Math.round((htPrice - (htPrice / 100) * promotion) * 100) / 100;
        buyingPriceU =
          Math.round((unitPrice - (unitPrice / 100) * promotion) * 100) / 100;

        promotionpercent = promotion;
        ttPrice =
          promotionAmountOrPersentage +
          (promotionAmountOrPersentage / 100) * tva + ratesOnTTC;
      }
    } else {
      promotionAmountOrPersentage =(Number(unitPrice) + Number(ratesOnHTC)) * Number(quantity);
          console.log("promotionAmountOrPersentage", promotionAmountOrPersentage)

      buyingPriceU = unitPrice;
      promotionpercent = 0;
      ttPrice =
        promotionAmountOrPersentage + (promotionAmountOrPersentage / 100) * tva + ratesOnTTC;
    }

    return [
      promotionAmountOrPersentage,
      buyingPriceU,
      promotionpercent,
      ttPrice,
    ];
  };
  testSKUExist(sku, listSKU) {
    let exist = false;
    if (listSKU !== undefined && listSKU !== null && listSKU.length > 0) {
      listSKU.forEach((element, index) => {
        if (element === sku) {
          exist = true;
        }
      });
    }

    return exist;
  }

  testSKUPattern(sku) {
    let exist = false;
    let pattern = /[A-Z][A-Z]/;

    if (pattern.test(sku)) {
      exist = true;
    }
    return exist;
  }

  generateSKU(name, listSKU) {
    if (name !== undefined && name !== null && name !== "") {
      let SKU = "";
      let arrayName = this.testElementVideinArray(name.split(" "));
      let exist = false;
      // let arraySize=arrayName.length;
      if (arrayName.length >= 2) {
        let firstWord = arrayName[0];
        let secondWord = arrayName[1];
        SKU = (
          Array.from(firstWord)[0] + Array.from(secondWord)[0]
        ).toUpperCase();
      } else if (arrayName.length === 1) {
        let firstWord = arrayName[0];
        SKU = (
          Array.from(firstWord)[0] + Array.from(firstWord)[1]
        ).toUpperCase();
      }
      exist = this.testSKUExist(SKU, listSKU);

      if (exist) {
        return "";
      } else {
        return "(On propose la référence : " + SKU + " )";
      }
    } else {
      return "";
    }
  }
  testElementVideinArray(arrayName) {
    arrayName.forEach((element, index) => {
      if (element === "" || element === " ") {
        arrayName.splice(index, 1);
      }
    });
    const existe = arrayName.indexOf("");
    if (existe > -1) {
      this.testElementVideinArray(arrayName);
    }
    return arrayName;
  }
  generateSKUCategory(name, listSKU) {
    if (name !== undefined && name !== null && name !== "") {
      let SKU = "";
      let arrayName = this.testElementVideinArray(name.split(" "));
      let exist = false;
      // let arraySize=arrayName.length;
      if (arrayName.length >= 3) {
        let firstWord = arrayName[0];
        let secondWord = arrayName[1];
        let thirdWord = arrayName[2];
        // console.log("name vide", "-" + thirdWord + "-");
        SKU = (
          Array.from(firstWord)[0] +
          Array.from(secondWord)[0] +
          Array.from(thirdWord)[0]
        ).toUpperCase();
      } else if (arrayName.length === 2) {
        let firstWord = arrayName[0];
        let secondWord = arrayName[1];

        SKU = (
          Array.from(firstWord)[0] +
          Array.from(firstWord)[1] +
          Array.from(secondWord)[0]
        ).toUpperCase();
      } else if (arrayName.length === 1) {
        let firstWord = arrayName[0];
        // let secondWord = arrayName[1];
        if (firstWord.length >= 3) {
          SKU = (
            Array.from(firstWord)[0] +
            Array.from(firstWord)[1] +
            Array.from(firstWord)[2]
          ).toUpperCase();
        }
      }
      if (SKU !== "") {
        exist = this.testSKUExist(SKU, listSKU);

        if (exist) {
          return "";
        } else {
          return "(On propose la référence : " + SKU + " )";
        }
      }
    } else {
      return "";
    }
  }
}
export default new UtilsFormule();
